// Phase 6.1 — Offline Quality/Safety field capture helpers.
// Reuses the existing IndexedDB queue (utils/offlineQueue). A queued QS record carries the
// governed operation + any photos captured offline as base64 data URLs. On reconnect the
// OfflineContext uploads the photos to /qs/evidence then replays the op via /qs/offline/sync
// (conflict-aware: auto-merges non-overlapping fields, flags true conflicts for manual review).
import { enqueueCapture } from '../utils/offlineQueue';

export function isOffline() {
  return typeof navigator !== 'undefined' && !navigator.onLine;
}

export function newClientKey() {
  return (window.crypto && window.crypto.randomUUID)
    ? window.crypto.randomUUID()
    : `ck-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function dataUrlToFile(dataUrl, name) {
  const [meta, b64] = dataUrl.split(',');
  const mime = (meta.match(/:(.*?);/) || [])[1] || 'image/jpeg';
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new File([arr], name, { type: mime });
}

// opType: 'quality.observation.create' | 'safety.observation.create' | 'inspection.create' | 'inspection.responses'
export async function queueQsOperation({ projectId, projectName, opType, payload, photos, label }) {
  return enqueueCapture({
    type: 'qs-op',
    projectId,
    projectName: projectName || '',
    label: label || opType,
    payload: { opType, opPayload: payload || {}, photos: photos || [] },
  });
}
